/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// document.addEventListener("DOMContentLoaded", function () {
//     console.log("✅ DOM Loaded - Checking .ProductMeta__Description .Rte");

//     const rteElements = document.querySelectorAll(".ProductMeta__Description .Rte");
//     console.log(`Found ${rteElements.length} .Rte elements`);

//     rteElements.forEach((rte, index) => {
//         console.log(`\n📂 Processing RTE ${index + 1}`);

//         const mediaElements = rte.querySelectorAll("img, video");
//         console.log(`🔍 Found ${mediaElements.length} media elements`);

//         mediaElements.forEach((media, mediaIndex) => {
//             console.log(`👉 Media ${mediaIndex + 1}: <${media.tagName.toLowerCase()}>`, media);

//             // ✅ Remove any <meta> tags in parent
//             let parent = media.parentNode;
//             if (parent) {
//                 const metaTags = parent.querySelectorAll("meta");
//                 metaTags.forEach(meta => {
//                     console.log("🗑 Removing meta tag:", meta);
//                     meta.remove();
//                 });
//             }

//             // ✅ Unwrap safely
//             while (parent && parent !== rte && ["P", "SPAN", "STRONG", "EM", "h1", "h2", "h3", "h4", "h5", "h6" ].includes(parent.tagName)) {
//                 console.log(`🔄 Unwrapping <${media.tagName.toLowerCase()}> from <${parent.tagName.toLowerCase()}>`);

//                 // Move media before the wrapper, then remove wrapper
//                 parent.parentNode.insertBefore(media, parent);
//                 parent.remove();

//                 // Update parent for next iteration
//                 parent = media.parentNode;
//             }
//         });
//     });

//     console.log("\n✅ Cleanup complete.");
// });



document.addEventListener('DOMContentLoaded', function () {
    console.log("Script loaded and DOM ready");

    const containers = document.querySelectorAll('.ProductMeta__Description .rte');
    console.log("Found containers:", containers.length);

    containers.forEach((container, index) => {
        console.log(`Processing container #${index + 1}`);

        const elements = container.querySelectorAll('p, span, div, strong, em, b, i, u, section, article, aside');
        console.log(`Found ${elements.length} possible wrappers`);

        elements.forEach(el => {
            const children = el.childNodes;
            let hasOnlyMedia = true;

            children.forEach(child => {
                if (child.nodeType === Node.ELEMENT_NODE) {
                    if (!(child.tagName === 'IMG' || child.tagName === 'VIDEO')) {
                        hasOnlyMedia = false;
                    }
                } else if (child.nodeType === Node.TEXT_NODE && child.textContent.trim() !== '') {
                    hasOnlyMedia = false;
                }
            });

            if (hasOnlyMedia && (el.tagName !== 'H1' && el.tagName !== 'H2' && el.tagName !== 'H3' && el.tagName !== 'H4' && el.tagName !== 'H5' && el.tagName !== 'H6')) {
                console.log(`Unwrapping ${el.tagName} because it only contains media`);
                while (el.firstChild) {
                    el.parentNode.insertBefore(el.firstChild, el);
                }
                el.remove();
            } else {
                console.log(`Keeping ${el.tagName} because it has text or other content`);
            }
        });
    });

    console.log("Script execution finished");
});
